// Money-суммирование живых полей формы (класс прод-брони 664209,
// 2026-07-21): очищенный инпут v-model даёт "" — сырой `+` превращает
// сложение в конкатенацию строк (32000 + "" -> "32000", каждый следующий
// + 0 дописывает символ ноля -> 3.2e+22 на экране). Любая сумма над
// редактируемыми money-полями обязана коэрцить каждый терм.

// ""/null/undefined/NaN-мусор -> 0; строковые числа -> число.
export function toMoneyNumber(value) {
  return Number(value) || 0;
}

export function sumMoney(values) {
  return values.reduce((sum, value) => sum + toMoneyNumber(value), 0);
}

// Разноска сумм платежей по типам касс (диалог выдачи, BookingCard.savePayment).
// Строки типов = чекбоксы PaymentDialog. fields — обязательный whitelist
// ключей платёжного объекта (холистик-ревью 2026-07-21): посторонние или
// будущие служебные ключи с .type/.sum не должны влиять на баланс клиента.
export const PAYMENT_TYPE_BUCKETS = {
  "Наличные": "cash",
  "Терминал": "cashless",
  "На карту": "card_to_card",
  "Р/с": "entity",
  "Баланс клиента": "client_balance",
};

export function sumPaymentsByType(payments, fields) {
  const totals = { cash: 0, cashless: 0, card_to_card: 0, entity: 0, client_balance: 0 };
  fields.forEach((field) => {
    const payment = payments[field];
    const bucket = payment && PAYMENT_TYPE_BUCKETS[payment.type];
    if (bucket) {
      totals[bucket] += toMoneyNumber(payment.sum);
    }
  });
  return totals;
}
